export function StyleHelpers (pEditor, pStyle)
{
  this.getCurrentStyleInRange = (att) =>
  {
    let currentParentElement,
        currentRange = pEditor.range.getCurrent(true),
        currentStyle = null;

    if (currentRange)
    {
      currentParentElement = (currentRange.startContainer.nodeType === 3) ? currentRange.startContainer.parentNode : currentRange.startContainer;

      if (currentParentElement && currentParentElement.nodeType === 1)
      {
        if (att === 'backgroundColor')
        {
          currentStyle = BEditor.styleHelpers.getElementRealBackground(currentParentElement, pEditor.iFrame);
          currentStyle = currentStyle.backgroundColor || '';
        }
        else
        {
          currentStyle = BEditor.styleHelpers.getElementStyle(currentParentElement, att, pEditor.iFrame);

          if (BEditor.browser.isIE && att === 'fontWeight' && !isNaN(currentStyle))
          {
            currentStyle = (currentStyle < 500) ? 'normal' : 'bold';
          }
        }
      }
    }

    return currentStyle;
  };
}